
import { A2AMessage } from '../types';
import { broadcast } from '../communication/broadcastService';
import { publishMessage } from '../communication/messagePublisher';

export function broadcastNotification(
  fromAgent: string,
  content: string,
  notificationType: 'info' | 'warning' | 'error' | 'success',
  relevantAgents?: string[]
): A2AMessage[] {
  const targetAgents = relevantAgents || ['executive-agent'];
  
  return broadcast(fromAgent, targetAgents, content, {
    messageType: 'NOTIFICATION',
    notificationType,
    timestamp: new Date().toISOString(),
    broadcastId: `broadcast-${Date.now()}`,
    intent: 'system-notification',
    priority: notificationType === 'error' ? 'high' : 'normal',
    routingBehavior: 'broadcast'
  });
}

export async function validateAgentResponses(messages: A2AMessage[]): Promise<A2AMessage> {
  // Ensure messages is an array and has items before calculating its length
  const messageCount = Array.isArray(messages) ? messages.length : 0;
  
  return await publishMessage({
    fromAgent: 'executive-agent',
    toAgent: 'user',
    content: `I've validated the responses from ${messageCount} agents and ensured they meet quality standards.`,
    signature: '',
    keyId: '',
    metadata: {
      protocol: 'A2A',
      version: '1.1',
      messageType: 'VALIDATION',
      validationStatus: 'successful'
    }
  });
}
